module.exports = __webpack_public_path__ + "img/noTasks.34566e91.svg";